module.exports = __webpack_public_path__ + "img/mozambique-logo-icon.a739d86d.png";